import { render } from "./info-data.vue?vue&type=template&id=80c7c864"
import script from "./info-data.vue?vue&type=script&lang=js"
export * from "./info-data.vue?vue&type=script&lang=js"

import exportComponent from "L:\\WEB\\burgimspreewald-ticketscanner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__